import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels, getColor } from "@/components/editor/utils/use-color";
import noScrollBar from "@/styles/no-scrollbar";

export const StyledNavigationMenu = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: ${rem(12)} 0;
  background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
`;

export const OverflowWrapper = withViewportStyle("div")`
position: relative;
${noScrollBar};

${(props) => props.$viewport.mobile`
  position: static;
`}
`;

export const ShadowWrapper = withViewportStyle("div")`
  --start-color: ${({ theme }) =>
    getColor(theme.colors[ColorLabels.BACKGROUND]).css()};

  --end-color: ${({ theme }) =>
    getColor(theme.colors[ColorLabels.BACKGROUND]).alpha(0.1).css()};

  position: relative;
  flex-grow: 1;
  overflow: auto;

  &::before,
  &::after {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: ${rem(55)};
    content: "";
    pointer-events: none;
  }

  &::before {
    z-index: var(--z-index-lowest);
    left: 0;
    background: 
      linear-gradient(
        to right,
        var(--start-color) 5%,
        var(--end-color) 30%
      );
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to right,
      var(--end-color) 10%,
      var(--start-color) 90%
    );
  }

  ${(props) => props.$viewport.mobile`
    position: static;

    &::before,
    &::after {
      content: unset;
    }
  `}
`;
